const compareAlarmPointValue = (first, second) => String(first || '').localeCompare(
  String(second || ''),
  undefined,
  { numeric: true, sensitivity: 'base' }
)

export const sortAlarmPointOptions = (alarmPoints = []) => [...alarmPoints].sort((first, second) => (
  compareAlarmPointValue(first.alarmPointId, second.alarmPointId)
  || compareAlarmPointValue(first.name, second.name)
  || compareAlarmPointValue(first.systemId, second.systemId)
))
